import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { SearchButtonComponent } from '../search-button/search-button.component';

@Component({
    selector: 'myabvv-filter',
    standalone: true,
    templateUrl: './filter.component.html',
    imports: [FormsModule, TranslatePipe, SearchButtonComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterComponent implements OnInit {

  @Input() isLoading: boolean;
  @Output() applyFilterEvent = new EventEmitter<void>();
  @Output() reinitializeFiltersEvent = new EventEmitter<void>();

  constructor() { }

  ngOnInit() {
  }

  onApplyFilter() {
    return this.applyFilterEvent.emit();
  }

  onReinitializeFilters() {
    return this.reinitializeFiltersEvent.emit();
  }
}
